import React from 'react';
import { BucketHeader } from '../../../../components/BucketHeader/BucketHeader';
import { PopularTimes } from '../../../../shared/popularTimes';
import { FormattedLocationResponse } from '../../../categoryBrowse/api';

interface EventTimeOptionsBucketProps {
    name: string;
    locationSlug: string;
}

export class EventTimeOptionsBucket extends React.PureComponent<EventTimeOptionsBucketProps> {
    render() {
        const { name, locationSlug } = this.props;

        const location: FormattedLocationResponse = {
            slug: locationSlug,
        };

        return (
            <div>
                <BucketHeader title={name} />
                <PopularTimes location={location} />
            </div>
        );
    }
}
